import { useEffect, useState } from "react";
import { Nav, Offcanvas } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { LiaAngleLeftSolid } from "react-icons/lia";
import {
  logoImg,
  mapIcon,
  compareIcon,
  reportsIcon,
  saveLoadIcon,
  plainTextIcon,
  importExportIcon,
} from "utils/data";

export const SidebarSection = ({ showSidebar, setShowSidebar }) => {
  const sidebarLinks = [
    {
      label: "Map View",
      icon: mapIcon,
      path: "/",
    },
    {
      label: "Compare",
      icon: compareIcon,
      path: "/compare",
    },
    {
      label: "Plain Text",
      icon: plainTextIcon,
      path: "/plain-text",
    },
    {
      label: "Import Export",
      icon: importExportIcon,
      path: "/import-export",
    },
    {
      label: "Reports",
      icon: reportsIcon,
      path: "/reports",
    },
    {
      label: "Save/Load",
      icon: saveLoadIcon,
      path: "/save-load",
    },
  ];

  const toogleOffcanvas = () => setShowSidebar(!showSidebar);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 992);
  useEffect(() => {
    window.addEventListener("resize", () => {
      setIsLargeScreen(window.innerWidth > 992);
    });
    if (isLargeScreen) {
      setShowSidebar(true);
    } else {
      setShowSidebar(false);
    }
  }, [isLargeScreen, setShowSidebar]);

  return (
    <>
      <Offcanvas
        show={showSidebar}
        onHide={toogleOffcanvas}
        scroll={true}
        backdrop={!isLargeScreen}
        className="sidebar"
      >
        <Offcanvas.Header>
          <Offcanvas.Title className="text-center w-100">
            <img src={logoImg} alt="Logo" width={150} />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav variant="pills flex-column gap-1">
            {sidebarLinks.map((link, index) => (
              <Nav.Item key={index}>
                <Nav.Link as="div">
                  <NavLink
                    to={link.path}
                    onClick={!isLargeScreen && toogleOffcanvas}
                    className={({ isActive }) =>
                      `${
                        isActive
                          ? "bg-orange text-dark active-sidebar-link"
                          : "text-white"
                      } text-decoration-none d-flex gap-3 align-items-center w-100 py-2 px-3 rounded-3 fw-bold`
                    }
                  >
                    <img src={link.icon} alt={link.label} width={20} />
                    {link.label}
                  </NavLink>
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>

      <button
        onClick={toogleOffcanvas}
        className="position-fixed btn btn-light d-inline-flex justify-content-center align-items-center rounded-circle p-0 border shadow-sm"
        style={{
          width: "2rem",
          height: "2rem",
          left: `calc(125px - 2rem)`,
          bottom: "1rem",
          zIndex: 100000,
          transform: `rotate(${showSidebar ? "0" : "180deg"})`,
        }}
      >
        <LiaAngleLeftSolid />
      </button>
    </>
  );
};
